export function isRole(email, role) {
  const roles = {
    sales: [
      'jaren.mccormick@canopytax.com',
      'jono.daly@canopytax.com',
      'chris.wyss@canopytax.com',
      'austin.scott@canopytax.com',
      'michael.salmon@canopytax.com',
      'armin.kadic@canopytax.com',
      'will.fowler@canopytax.com',
    ],
    success: [
      'tiffany.timmermann@canopytax.com',
      'matt.gagon@canopytax.com',
      'daniel.douglas+12345@canopytax.com',
      'daniel.douglas@canopytax.com',
      'whitley.gordon@canopytax.com',
      'jeff.kinsel@canopytax.com',
      'Terrance.sherrell@canopytax.com',
      'keila.akers@canopytax.com',
    ],
    support: [
      'geoff.parker@canopytax.com',
      'emily.guaktier@canopytax.com',
      'sami.sherrell@canopytax.com',
      'lisa.knapp@canopytax.com',
      'reina.rodriguez@canopytax.com',
      'joelle.robinson@canopytax.com',
      'elliot.rose@canopytax.com',
      'brandon.woodward@canopytax.com',
    ],
    sdr: [
      'jake.godfrey@getcanopy.com',
      'cade.downs@getcanopy.com',
      'collin.gibb@getcanopy.com',
      'daniel.ruales@getcanopy.com',
      'mckade.hunter@getcanopy.com',
      'sadie.hunter@getcanopy.com',
      'skyler.ebreo@getcanopy.com',
      'jacob.curtis@getcanopy.com',
      'kyle.starr@getcanopy.com',
    ],
  };
  return roles[role].includes(email);
}

export function hasLicense(user, license) {
  if (!Array.isArray(user.licenses)) return false;
  return user.licenses.includes(license);
}
